import React from "react";
import classNames from "classnames/bind";

import {Screen} from "../../components/Screen";
import {useStateManager} from "../../utils/useStateManager";
import {phoneAsFioFormValidation} from "../Registration/validation";
import {Field, Form} from "react-final-form";
import {FormEmailAndPhoheScreenValues} from "../Registration";
import {InputPhone} from "../../components/InputPhone";
import {Input} from "../../components/Input";

import styles from "./PhoneAndEmailScreen.module.css";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: (exists?: boolean) => void;
};

export const PhoneAndEmailScreen: React.FC<Props> = (props) => {
  const {patient, updatePatient, linkInfo} = useStateManager();

  /*Видимость полей через query params*/
  const fields= ['phone', 'email']
  const params = new URLSearchParams(window.location.search);
  const isQueryVisibleFieldsUsed = fields.filter(field => params.get(`${field}_visible`) !== null).length > 0;

  const showPhoneField = isQueryVisibleFieldsUsed ? params.get('phone_visible') !== "false" :  linkInfo?.custom?.custom_показывать_экран_с_вводом_телефона_для_записи_в_имя || false;
  const showEmailField =  isQueryVisibleFieldsUsed ? params.get('email_visible') !== "false" : linkInfo?.custom?.custom_показывать_экран_с_вводом_эл_почты || false;
  const isPhoneRequired = linkInfo?.custom?.custom_обязательность_телефон || false
  const isEmailRequired = linkInfo?.custom?.custom_обязательность_эл_почта || false

  const validationInfo = {
    phone: {
      showPhoneField : showPhoneField,
      isPhoneRequired: isPhoneRequired
    },
    email: {
      showEmailField : showEmailField,
      isEmailRequired: isEmailRequired
    }
  }

  const handleSubmit = async ({...formValues}: FormEmailAndPhoheScreenValues) => {
    const data = {
      custom_firstname: formValues.custom_phone,
      custom_телефон:  formValues.custom_phone,
      custom_login: formValues.custom_login
    };

    if(!showPhoneField) {
      delete data.custom_firstname;
      delete data.custom_телефон;
    }

    if(!showEmailField) {
      delete data.custom_login;
    }

    updatePatient(data)
    props.onSubmit()
  }

  const getText = () => {
    switch(true) {
      case showPhoneField && showEmailField: return 'Телефон и эл. почта нужны';
      case showPhoneField: return 'Телефон нужен';
      case showEmailField: return 'Эл. почта нужна';
      default: return  ""
    }
  }

  type FormFieldProps = React.ComponentProps<typeof Input> & {
      name: keyof FormEmailAndPhoheScreenValues;
  };
  const FormField: React.FC<FormFieldProps> = (props) => (
    <Field name={props.name}>
      {({ input, meta }) => (
        <Input
          {...input}
          label={props.label}
          required={props.required}
          mask={props.mask}
          error={meta.touched ? meta.error : undefined}
        />
      )}
    </Field>
  );

  return (
    <>
      <Form<FormEmailAndPhoheScreenValues>
        initialValues={
          {
            custom_phone: patient?.custom_телефон || "",
            custom_login: patient?.custom_login || ""
          }
        }
        validate={(values: FormEmailAndPhoheScreenValues) => phoneAsFioFormValidation(values, validationInfo)}
        validateOnMount
        onSubmit={handleSubmit}
      >
        {({handleSubmit, valid}) => {
          return (
            <Screen
              title="Сейчас мы вас зарегистрируем"
              buttonTitle='Продолжить'
              onSubmit={handleSubmit}
              isInvalid={!valid}
            >
              <p className={cx("form-text")}>
                  {`${getText()} для связи консультанта с вами`}
              </p>
              <div className={cx("form-body")}>
                {showEmailField &&
                  <FormField
                    name="custom_login"
                    label="Эл.почта"
                    required={false}
                  />
                }
                {showPhoneField &&
                  <Field name="custom_phone">
                    {({input, meta}) => (
                      <InputPhone
                        {...input}
                        label="Телефон"
                        required={false}
                        error={meta.touched ? meta.error : undefined}
                      />
                    )}
                  </Field>
                }
              </div>
            </Screen>
          );
        }}
      </Form>
    </>
  )
}